<template>
    <div>
        <edit-room :expoId="expoId" :roomId="editId" :roomData="roomData"/>
        <div class="expo">
            <vue-draggable-resizable
                class="edit-link"
                class-name-active="edit-link-active"
                v-for="item in roomsOnMap"
                :key="item.id"
                :x="item.x"
                :y="item.y"
                :w="item.w"
                :h="item.h"
                :parent="true"
                @activated="onActivated(item.id)"
                @deactivated="onDeactivated(item.id)"
                @dragstop="(x, y) => onDragStop(item.id, x, y)"
                @resizestop="(x, y, w, h) => onResizeStop(item.id, x, y, w, h)"
            >
                <div class="edit-wrapper">
                    <transition name="fade">
                        <div v-show="activeId == item.id" class="edit-options">
                            <div class="tooltip">
                                {{ item.name }}
                            </div>
                            <div class="option"><div @click="editRoom(item.id)" class="circle grow-link">
                                <MdCreateIcon/><span class="tooltip">Edit</span>
                            </div></div>
                            <div class="option"><div @click="deleteRoom(item.id)" class="circle grow-link">
                                <MdTrashIcon/><span class="tooltip">Delete</span>
                            </div></div>
                        </div>
                    </transition>
                    <div class="small-content">
                        <VideoLoop :hd="false" :iframe="item.iframe"/>
                    </div>
                    <img class="room-img" :src="item.img">
                </div>
            </vue-draggable-resizable>
        </div>
        <div @click="$router.push('/expo/' + expoId)" class="fixed-icon top-left grow-link back-link">
            <span class="tooltip">Go Back</span>
            <MdArrowBackIcon/>
        </div>
        <div @click="newRoom" class="circle grow-link fixed-icon bot-right">
            <MdAddIcon/><span class="tooltip">New Room</span>
        </div>
    </div>
</template>

<script>
import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
import MdAddIcon from 'vue-ionicons/dist/md-add.vue'
import MdCreateIcon from 'vue-ionicons/dist/md-create.vue'
import MdTrashIcon from 'vue-ionicons/dist/md-trash.vue'
import MdArrowBackIcon from 'vue-ionicons/dist/md-arrow-back.vue'
import { nanoid } from 'nanoid'

import EditRoom from './EditRoom'
import VideoLoop from './room/content/VideoLoop'

import { firestore } from '../../db'
const expos = firestore.collection('expos')

export default {
    name: 'EditMap',
    props: ['expoId'],
    components: {
        VueDraggableResizable,
        MdAddIcon, MdCreateIcon, MdTrashIcon, MdArrowBackIcon,
        EditRoom,
        VideoLoop
    },
    data() {
        return {
            expoData: {},
            activeId: null,
            editId: null
        }
    },
    computed: {
        name() { return this.expoData.name },
        roomData() {
            if (!this.expoData || !this.editId) {
                return {
                    name: '',
                    iframe: '',
                    img: '',
                }
            }
            return this.expoData.rooms[this.editId]
        },
        roomsOnMap() {
            const rooms = { ...this.expoData.rooms }
            delete rooms.map
            return rooms
        }
    },
    methods: {
        onActivated(id) {
            this.activeId = id
        },
        onDeactivated() {
            this.activeId = null
        },
        onDragStop(id, x, y) {
            const rooms = { ...this.expoData.rooms }
            if (rooms[id].x == x && rooms[id].y == y) {
                return
            }
            rooms[id].x = x
            rooms[id].y = y
            this.$firestoreRefs.expoData.update({ rooms: rooms })
                .catch(e => { console.log(e) })
        },
        onResizeStop(id, x, y, w, h) {
            const rooms = { ...this.expoData.rooms }
            if (rooms[id].x == x && rooms[id].y == y && rooms[id].w == w && rooms[id].h == h) {
                return
            }
            rooms[id].x = x
            rooms[id].y = y
            rooms[id].w = w
            rooms[id].h = h
            this.$firestoreRefs.expoData.update({ rooms: rooms })
                .catch(e => { console.log(e) })
        },
        newRoom() {
            var roomId = nanoid(10)
            var obj = {}
            obj['rooms.' + roomId] = {
                name: 'New Room',
                iframe: '',
                id: roomId,
                img: '',
                w: 200,
                h: 200,
                x: 500,
                y: 200
            }
            this.$firestoreRefs.expoData.update(obj)
                .then(() => {
                    this.editRoom(roomId)
                })
                .catch(e => console.log(e))
        },
        deleteRoom(id) {
            const rooms = { ...this.expoData.rooms }
            delete rooms[id]
            this.$firestoreRefs.expoData.update({ rooms: rooms })
                .catch(e => { console.log(e) })
        },
        editRoom(id) {
            this.editId = id
            this.$modal.show('edit-room')
        }
    },
    watch: {
        expoId: {
            immediate: true,
            handler(expoId) {
                this.$bind('expoData', expos.doc(expoId))
            }
        },
        name: {
            immediate: true,
            handler(name) {
                if (!name) {
                    return
                }
                this.$store.dispatch('updatePageName', [{
                    name: 'Edit: ' + name,
                    to: '/editexpo/' + this.expoId
                }])
            }
        }
    },
}
</script>

<style lang="scss" scoped>
@import '../../expo.scss';

.edit-wrapper {
    transition: transform 0.2s ease;
    -webkit-transform: scale(0.8);
    -ms-transform: scale(0.8);
    transform: scale(0.8);
    position: relative;
    height: 100%;
    width: 100%;
}
.edit-link {
    position: absolute;
    cursor: grab;
    border: none;
    z-index: none;

    img {
        width: 33.333%;
    }
    .small-content {
        width: 100%;
        padding-top: 100%;
    }
    &:active {
        cursor: grabbing;
    }
}
.edit-link-active {
    z-index: 200 !important;
    .edit-wrapper {
        -webkit-transform: scale(1);
        -ms-transform: scale(1);
        transform: scale(1);
    }
}

.edit-options {
    position: absolute;
    top: -55px;
    display: flex;
    width: 100%;
    .tooltip {
        position: absolute;
        top: 30px;
        font-size: 20px;
    }
    .option {
        position: relative;
        display: inline-block;
        .circle {
            height: 40px;
            width: 40px;
            font-size: 20px;
            .tooltip {
                top: -30px;
            }
        }
    }
}
</style>